<div class="triggers-container">
  <div class="conditions-list">
    <p-table
      [value]="triggers"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[5, 10, 20]"
      [globalFilterFields]="['value.subjectName', 'value.kommentar']"
      [scrollable]="true"
      scrollHeight="400px"
    >
      <ng-template pTemplate="header">
        <tr>
          <th id="tipo-column">Tipo</th>
          <th id="id-column">ID</th>
          <th id="descripcion-column">Descripción</th>
          <th id="filtro-pr-column">Filtro Pr.</th>
          <th id="filtro-ai-column">Filtro AI.</th>
          <th id="orden-column">Orden</th>
          <th id="estado-column">Estado</th>
          <th id="evento-column">Evento</th>
          <th id="filtro-pet-column">Filtro Pet.</th>
          <th id="debug-column">Debug</th>
          <th id="comentario-column">Comentario</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-triggerControl let-rowIndex="rowIndex">
        <tr>
          <td>
            <span *ngIf="triggerControl.value.subjectTypeDescription">
              {{ triggerControl.value.subjectTypeDescription }} ({{ triggerControl.value.subjectType }})
            </span>
            <span *ngIf="!triggerControl.value.subjectTypeDescription">
              {{ triggerControl.value.subjectType }}
            </span>
          </td>
          <td>{{ triggerControl.value.subjectID }}</td>
          <td>{{ triggerControl.value.subjectName }}</td>
          <td>{{ triggerControl.value.methNrFilter }}</td>
          <td>{{ triggerControl.value.alarmFilter }}</td>
          <td>{{ triggerControl.value.posR }}</td>
          <td>
            <span *ngIf="triggerControl.value.ruleStateDescription">
              {{ triggerControl.value.ruleStateDescription }} ({{ triggerControl.value.ruleState }})
            </span>
            <span *ngIf="!triggerControl.value.ruleStateDescription">
              {{ triggerControl.value.ruleState }}
            </span>
          </td>
          <td>
            <span *ngIf="triggerControl.value.triggEventDescription">
              {{ triggerControl.value.triggEventDescription }} ({{ triggerControl.value.triggEvent }})
            </span>
            <span *ngIf="!triggerControl.value.triggEventDescription">
              {{ triggerControl.value.triggEvent }}
            </span>
          </td>
          <td>{{ triggerControl.value.auftrNrTest }}</td>
          <td>{{ triggerControl.value.debug }}</td>
          <td>{{ triggerControl.value.kommentar }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="11" style="text-align: center">
            No hay disparadores definidos
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
